<script>
    
    import { toast } from 'bulma-toast'
    import { noticesStore, noticeStore, modalStore } from '../stores'

    import NoticesService from '../$services/notices.service'

    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'
    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'
    import Textarea from '../$components/textarea.svelte'

    let data = {
        index: $noticeStore.index,
        title: $noticeStore.title,
        text: $noticeStore.text,
        expired: $noticeStore.expired,
        link: $noticeStore.link,
        display: $noticeStore.display,
    }

    let loading = false

    async function updateNotice() {

        loading = true
        const resp = await NoticesService.updateNotice($noticeStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        noticesStore.replace(resp.data)
        noticeStore.set(resp.data)

        toast({message: 'Aviso actualizado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={ updateNotice } { loading } >

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.title} label="Título" placeholder="Título" />
        </div>
        <div class="column">
            <Select
                bind:value={data.display}
                label="Display"
                options={[
                    {value: 'home', text: 'Home'},
                    {value: 'bar', text: 'Bar'},
                ]}
            />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.index} label="Prioridad" placeholder="Prioridad" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.link} label="Link" placeholder="Link" required={false} />
        </div>
    </div>

    {#if $noticeStore.type === 'text'}
        <div class="columns">
            <div class="column">
                <Textarea bind:value={data.text} label="Texto" placeholder="Texto" />
            </div>
        </div>
    {/if}

    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>

    <div class="items-end space-top">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
        <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
    </div>

</Form>